export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/external-participation`;
    const url = `${baseUrl}/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/ExternalParticipation/index.js